import { createContext, useContext } from 'react';

const ReferContext = createContext(null);

export const useRefer = () => {
  const context = useContext(ReferContext);
  if (!context) {
    throw new Error('useRefer must be used within a ReferProvider');
  }
  return context;
};

export default ReferContext;
